import React, { useState } from 'react';

import Footer from '../../components/Footer';
import Nav from '../../components/Nav';
import Whatsapp from '../../components/Whatsapp';
import anthony from '../../assets/board/anthony.svg';
import banner from '../../assets/brick.png';
import barau from '../../assets/board/barau.jpg';
import bayo from '../../assets/team/bayo.jpeg';
import darren from '../../assets/team/darren.png';
// import lekan from '../../assets/team/lekan.svg'
import charles from '../../assets/board/charles.svg';
// import mail from "../../assets/mailicon.svg";
import close from '../../assets/exit2.svg';
// import donli from '../../assets/board/donli.jpg';
import fifi from '../../assets/board/fifi.svg';
import francis from '../../assets/team/francis.jpeg';
import hakeem from '../../assets/board/hakeem.svg';
import logo from '../../assets/logobig.svg';
import patel from '../../assets/team/patel.svg';
import story from '../../assets/story.jpg';
import styles from './index.module.scss';

// import noname from '../../assets/board/noname.svg'
// import nonameteam from '../../assets/team/nonameteam.svg'
// import { Link } from "react-router-dom";

const About = () => {
  const [current, setCurrent] = useState('story');
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const team = [
    {
      image: francis,
      name: 'FRANCIS EKENG ',
      position: 'Chief Executive Officer',
      message:
        'An entrepreneur with over 25 years’ experience in various executive management positions. An alumnus of University of Ibadan -Nigeria; London Business School, London; Lagos Business School - Nigeria and IESE Business School – Barcelona, Francis is an international businessman with businesses in East, West and Southern Africa. Francis has keen eye in identifying profitable opportunities across various business verticals and develops innovative strategies enabled by new technologies in emerging markets.',
      mail: ''
    },
    {
      image: darren,
      name: 'DARREN SPENCER',
      position: 'Managing Director',
      message:
        'Following long service in the British Army Darren embarked on a career that has seen him successfully undertake senior executive roles in the development and implementation of infrastructure projects, primarily in Africa. A seasoned C-level executive, he has led successful projects/businesses over past 25 years in the Defence, Air Traffic Control, Telecoms and Construction industries across the UK, Middle East & African markets. Darren is a start-up expert and has held CEO & Group CEO positions in several high-profile companies. He has spent the last 20 years living and working in Africa (including Nigeria, Ghana, Sudan and Tanzania) and is passionately committed to ensuring that both urban and rural communities have access to homes in the shortest possible time. His other passion is CSR (Corporate, Social, Responsibility) programmes, having successfully managed such programmes in previous enterprises, and will ensure that CSR be at the heart of everything FirstHomes Africa does.',
      mail: ''
    },
    // {
    //   image: bayo,
    //   name: 'BAYO OGUNNUSI ',
    //   position: 'Chief Financial Officer',
    //   message:
    //     'An accomplished financial strategist with over 19 years’ experience in the private and public sector. His work life spans extensively across SME (Small and Medium Enterprise), Financial Control, Public Service, Infrastructure and Project Finance (PPP).  He’s a Chartered Accountant and an Associate of the Chartered Institute of Taxation. He has a Masters in Finance (M.Sc.) from London Business School, a Certificate in Entrepreneurial Management from the Enterprise Development Center (EDC-Lagos Business School), and he is a Certified Public Private Partnership Specialist from the Institute of Public Private Partnership in Washington, USA).',
    //   mail: ''
    // },
    {
      image: patel,
      name: 'SURLAK PATEL',
      position: 'Chief Technical Officer',
      message:
        'A Techno-Commercial Consultant and Entrepreneur with over 18 years experience in various industries spanning from Shipping, eCommerce, Telecom, HealthCare, Real Estate to Education. He has attained AWS Consulting Partnership and has driven various engagements with IBM Cloud, Microsoft and Oracle. He has a proven track record in shaping and delivering high quality products, solutions, services and change initiatives to a global user base across various businesses and carries vast experience across Web, Mobile, Cloud, IoT, and Blockchain.',
      mail: ''
    },
    {},
    {},
    {}
  ];

  const board = [
    {
      image: charles,
      name: 'CHARLES INYANGETE ',
      position: 'Chairman Advisory Board',
      message:
        'Professor Inyangete’s visionary and transformational leadership propelled the Nigeria Mortgage Refinance Company PLC from a fledgling start up to one of the top 50 most innovative companies in Nigeria. Under his leadership the NMRC executed the first mortgage-backed bond issue in 2015 and concluded preparations for a second bond issue in 2018 as part of a N440bn (USD 1.45bn) bond issuance programme. Under his leadership drove implementation of the first mortgage industry-wide Uniform Underwriting Standards. He proposed and adopted the value chain approach to tackling the challenges of the housing market comprising multi-faceted and complex operators, systems and processes along a supply and demand continuum.  ',
      mail: ''
    },
    {
      image: fifi,
      name: 'FIFI EJINDU ',
      position: 'Member Advisory Board',
      message:
        'Fifi Ekanem Ejindu is a Nigerian Architect, businesswoman and philanthropist. She has been featured on CNN African voices as one of the female African pioneers of Architecture and business, as well as the 2018 edition of the Famous African Women Architects published by People Maven. Fifi, as she is popularly known, is one of the most celebrated Architects and businesswomen in Nigeria. Educated at the prestigious Massachusetts Institute of Technology, Boston, USA; Pratt Institute School of Architecture, New York, U.S.A; Queens College, Yaba, Lagos, Senior Staff Primary School, University of Ibadan, she is the Chairperson of StarCrest Group of Companies; CEO, Building Support Systems; Executive Director, Delmar Group of Companies, Principal Partner of StarCrest Associates, an Architectural Firm, 1995 till date.',
      mail: ''
    },
    {
      image: hakeem,
      name: 'HAKEEM OGUNNIRAN ',
      position: 'Member Advisory Board',
      message:
        ' Visionary, entrepreneurial and highly qualified senior executive with broad knowledge and experience in strategy formulation and implementation, customer development/ management, logistics and supply chain management, negotiation and contract administration, project management, wholesale distribution, marketing, merchandising, change management, managing strategic alliances and general corporate administration. Result-driven, motivational management style with an excellent track record and proven ability of building and retaining highly motivated teams, maximizing productivity and achieving accelerated growth.',
      mail: ''
    },
    {
      image: barau,
      name: 'SULAIMAN BARAU',
      position: 'Member Advisory Board',
      message:
        "Born on the 14th of August, 1959, Alhaji Suleiman Barau attended the Ahmadu Bello University Zaria, where he obtained a Bachelor of Science degree in Economics. He also attended University of Bradford, England and the University of Jos where he obtained Postgraduate Certificate in Planning and Appraisal of Industrial Projects and an M.SC in Economics (Money and Finance) respectively.  A respected Banker and Economist, he began his working career with the Nigerian Mining Corporation as a Civil Servant in 1981 where he rose to the position of Principal Economist. During his employment with the Nigerian Mining Corporation, Suleiman conducted marketing and economic studies that led to the production of several mineral raw materials.He then moved to Continental Merchant Bank Limited in 1988 where he rose to the position of Deputy Manager and later became a Principal Manager with the Bank of the North Limited.He then moved to United Bank for Africa Plc as a Principal Manager (Treasury and Financial Institutions) and eventually headed the New York Branch Marketing Team at the Head Office of the Bank. He then joined FSB International Bank Plc and left in 2005 as a General Manager (Treasury, Financial Institutions and Private Bank) to take up appointment as a Special Adviser to the Governor of the Central Bank of Nigeria. Before joining Central Bank of Nigeria in 2005, Suleiman's banking experience was substantially in the areas of Treasury and Investment Banking, Corporate Finance, Credit Analysis, Financial Institutions, Relationship Management and Private Banking.As Special Adviser to the Governor, he also gathered some Manufacturing and Currency Printing experience when he con-currently acted as the Managing Director and Chief Executive Officer of the Nigerian Security Printing and Minting Company from 2nd of March to 1st of June, 2007 and has been a Board Member of the same company since March 2005.  Suleiman was appointed to the Board of CBN as the Deputy Governor, Operations on the 13th of December, 2007.  He has attended and facilitated several courses and conferences both at home and abroad. He is a Railway enthusiast and enjoys Soccer and Geography. He is married with children.",
      mail: ''
    },
    // {
    //   image: donli,
    //   name: 'JUSTICE H.N. DONLI',
    //   position: 'Member Advisory Board',
    //   message:
    //     'Justice Hansine Napwaniyo Donli (Rtd)  is the Founding President of the ECOWAS Community Court of Justice (CCJ). She has held several positions in the legal field both public and private,  and is therefore blessed with deep and diverse experience in the study and administration of the Law. She had earlier served as a high court judge and the  Kaduna State Attorney-General and Commissioner for Justice before her appointment as the president of the ECOWAS Community Court of Justice. She has also attended a number of international seminars and workshops on law and social development in different countries including Washington US, UK, PARIS etc. Justice Hansine Napwaniyo Donli (Rtd) is a recipient of several local and international awards, including the highest award of  honour from the Government of Benin Republic.',
    //   mail: ''
    // },
    {
      image: anthony,
      name: 'ANTHONY EBISIKE ',
      position: 'Member Advisory Board',
      message:
        'Obioma Anthony Ebisike is an economist, certified public accountant (CPA) and a chartered accountant. He holds a PhD. in Economics (with honors) from The New School for Social Research in New York, a Master’s degree in Real Estate Finance & Investments from New York University in New York, and a Bachelor’s degree in Accounting (Magna cum Laude) with minors in Finance and in Economics from The College of Staten Island, The City University of New York.   Dr. Ebisike has extensive work experience and has held senior management positions at industry leading USA firms, such as Douglas Elliman Real Estate, ICON Investments, Hines Interests LP and was an Audit & Advisory Services Manager at Deloitte & Touche LLP.   Dr. Ebisike is a faculty member at the NYU Real Estate Institute, New York. He is the author of two books (i) Real Estate Accounting Made Easy and (ii) The Fallouts: Banks and Financial Crises. He is also member of the Institute of Chartered Accountant of Nigeria (ICAN) and American Institute of Certified Public Accountant (AICPA).',
      mail: ''
    }
  ];

  const setValues = index => {
    setIndex(index);
    return setOpen(true);
  };
  const details = {
    story: {
      head: 'We See Possibilities where others see Limitations.',
      desc:
        'We believe that young Africans deserve financial freedom and have a right to build a richer Africa through harnessing the vehicle of home ownership.',
      body: (
        <div className={styles.body}>
          <div className={styles.middle}> Our Story </div>
          <p>
            30 years ago, a generation of Africans were given the opportunity to
            build lives that surpassed their circumstances and to fulfil dreams
            their parents had never imagined. For many this involved gaining the
            ability to own land and build homes.
          </p>
          <p>
            Today, access and opportunity are converging in an altogether new
            way – through the virtual and technological spaces of the Fourth
            Industrial Revolution, digital innovations and mobile connectivity.
            At FirstHomes Africa, we believe that this new space is the platform
            for young Africans to take the next leap in economic development and
            wealth creation through home ownership in the 21st century.
          </p>
          <p>
            We believe that owning a home is more than a roof over your head but
            a decision about your financial future. By empowering young Africans
            to make this vital step, we believe we will be building the
            foundation for a more equitable Africa whose people will be richer
            for it.
          </p>
        </div>
      )
    },
    culture: {
      head: 'Our Beliefs,\n Our Identity.',
      desc:
        'We are true to ourselves and committed to our mission of working together to deliver a unique solution for generations to come',
      body: (
        <div className={styles.body}>
          <div className={styles.middle}> Our core values</div>
          <p>
            At FirstHomes Africa, we challenge the status quo and believe in
            winning together.
          </p>
          <div className={styles.two}>
            <div>
              <p>
                <b> We Are Family </b> <br /> We take care of and support each
                other, aspiring to empower the next generation.
              </p>
              <p>
                <b> We Innovate </b> <br />
                We dare to dream, raising the bar and seeking ways to create
                abundance.
              </p>
              <p>
                <b> We Collaborate </b> <br />
                We succeed by doing and we respect each other's views and
                opinions.
              </p>
              <p>
                <b> We are Data Driven </b> <br />
                We pride ourselves on being experts in our fields and make
                decision on proven facts, not feelings.
              </p>
            </div>
            <div className={styles.image}>
              <img src={story} alt='story' />
            </div>
          </div>
        </div>
      )
    },
    team: {
      head: 'Vision Meets\n Passion',
      desc:
        'For our team, making home ownership attainable is not just a solution, it’s an obsession',
      body: (
        <div className={styles.body}>
          <div className={styles.middle}>Our Team</div>
          <div className={styles.boxes}>
            {team.map((t, i) => (
              <div
                key={i}
                className={`${styles.box} ${t.image ? '' : styles.empty}`}
                style={{
                  background: `url(${t.image}) center center`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat'
                }}
                onClick={t.image ? () => setValues(i) : null}
              >
                {t.name && (
                  <div className={styles.mini}>
                    <div className={styles.name}> {t.name} </div>
                    <div className={styles.pos}> {t.position} </div>
                  </div>
                )}
              </div>
            ))}
            {open && (
              <div className={styles.modal}>
                <div className={styles.body}>
                  <div className={styles.close} onClick={() => setOpen(false)}>
                    <img src={close} alt='' />
                  </div>
                  <div className={styles.details}>
                    <div className={styles.detail}>
                      <div
                        className={styles.image}
                        style={{
                          background: `url(${team[index].image}) center center`,
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat'
                        }}
                      />
                      <div className={styles.top}> {team[index].name} </div>
                      <div> {team[index].position} </div>
                      {/* <div className={styles.mail}>
                        <Link to={team[index].mail}>
                          <img src={mail} alt="" />
                        </Link>
                      </div> */}
                    </div>
                    <div className={styles.message}>{team[index].message}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    },
    board: {
      head: 'Unrivalled \n Expertise',
      desc:
        'As we challenge the status quo, the guidance from our advisory board of accomplished industry experts gurantees our success.',
      body: (
        <div className={styles.body}>
          <div className={styles.middle}>Advisory board </div>
          <div className={styles.boxes}>
            {board.map((t, i) => (
              <div
                key={i}
                className={styles.box}
                //style={{
                //  background: `url(${t.image}) center left`,
                //  backgroundSize: "100% 100%",
                //   backgroundRepeat: "no-repeat"
                //  }}
                onClick={() => setValues(i)}
              >
                <div className={styles.imgs}>
                  <img src={t.image} alt='avatar' />
                </div>
                <div className={styles.mini}>
                  <div className={styles.name}> {t.name} </div>
                  <div className={styles.pos}> {t.position} </div>
                  {/*                   <div>
                                                        <Link to={t.mail}>
                                                          <img src={mail} alt="" />
                                                        </Link>
                                                      </div> */}
                </div>
              </div>
            ))}
            {open && (
              <div className={styles.modal}>
                <div className={styles.body}>
                  <div className={styles.close} onClick={() => setOpen(false)}>
                    <img src={close} alt='' />
                  </div>
                  <div className={styles.details}>
                    <div className={styles.detail}>
                      <div
                        className={styles.image}
                        style={{
                          background: `url(${board[index].image})`,
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat'
                        }}
                      />
                      <div className={styles.top}> {board[index].name} </div>
                      <div> {board[index].position} </div>
                    </div>
                    <div className={styles.message}>{board[index].message}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    }
  };
  return (
    <div className={styles.about}>
      <Whatsapp />
      <Nav showBackground address />
      <div className={styles.main}>
        <div
          className={styles.back}
          style={{
            background: `url(${banner})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className={styles.inner}>
            <div className={styles.head}>
              <div>
                {details[current].head.split('\n').map((item, i) => {
                  return <div key={i}> {item} </div>;
                })}
              </div>
              <div className={styles.small}> {details[current].desc} </div>
            </div>
            <img src={logo} alt='logo' />
          </div>
        </div>
        <div className={styles.header}>
          <div className={styles.tabs}>
            <button
              className={current === 'story' ? styles.active : ''}
              onClick={() => setCurrent('story')}
            >
              <div className={styles.under}> Our Story </div>
            </button>
            <button
              className={current === 'culture' ? styles.active : ''}
              onClick={() => setCurrent('culture')}
            >
              <div className={styles.under}> Our Core Values </div>
            </button>
            <button
              className={current === 'team' ? styles.active : ''}
              onClick={() => setCurrent('team')}
            >
              <div className={styles.under}> Team Profiles </div>
            </button>
            <button
              className={current === 'board' ? styles.active : ''}
              onClick={() => setCurrent('board')}
            >
              <div className={styles.under}> Board Members </div>
            </button>
          </div>
        </div>
        <div className={styles.content}> {details[current].body} </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
